import firebaseChatService from '../services/firebaseChatService';
import { FIREBASE_GO_OFFLINE } from '../actions';

const firebaseMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case FIREBASE_GO_OFFLINE:
      return firebaseChatService.goOffline();
    default:
      return next(action);
  }
};

export default firebaseMiddleware;
